import script from "./TagListCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagListCard.vue?vue&type=script&setup=true&lang=ts"

import "./TagListCard.vue?vue&type=style&index=0&id=3223ea5a&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3223ea5a"]])

export default __exports__